import { GradientButton } from "@/components/ui/gradient-button";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SparklesCore } from "@/components/ui/sparkles";

export const Hero = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="container mx-auto px-4 py-16 md:py-24">
      <div className="text-center max-w-3xl mx-auto">
        <div className="relative mb-6">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900">
            <span className="flex flex-col md:flex-row md:items-center md:justify-center md:gap-2">
              <span>Bem-Vindo ao</span>
              <div className="relative">
                <span className="relative z-10">Sonho</span>
                {/* Lighting effect gradients - positioned absolutely under "Sonho" */}
                <div className="absolute inset-x-0 top-full bg-gradient-to-r from-transparent via-primary to-transparent h-[2px] w-full blur-sm" />
                <div className="absolute inset-x-0 top-full bg-gradient-to-r from-transparent via-primary to-transparent h-px w-full" />
                <div className="absolute inset-x-0 top-full bg-gradient-to-r from-transparent via-secondary to-transparent h-[5px] w-3/4 blur-sm mx-auto" />
                <div className="absolute inset-x-0 top-full bg-gradient-to-r from-transparent via-secondary to-transparent h-px w-3/4 mx-auto" />
                
                {/* Sparkles container with mask for top reflection effect */}
                <div className="absolute -z-0 left-0 right-0 top-[calc(100%+1px)] h-5 overflow-hidden">
                  <SparklesCore 
                    className="w-full h-full"
                    particleColor="#FF6B6B"
                    number={{
                      density: {
                        enable: true,
                        width: 200,
                        height: 15
                      },
                      value: 15
                    }}
                    speed={0.4}
                    minSize={0.4}
                    maxSize={1}
                    background="transparent"
                  />
                  {/* Radial gradient mask for top reflection effect */}
                  <div className="absolute inset-0 w-full h-full bg-background [mask-image:radial-gradient(100px_30px_at_top,transparent_30%,white)]" />
                </div>
              </div>
            </span>
          </h1>
        </div>
        <p className="text-xl text-gray-600 mb-8">
          {t('hero.subtitle')}
        </p>
        <div className="flex justify-center">
          <GradientButton onClick={() => navigate('/signup')}>
            Junta-te como Profissional da Cultura em Portugal
            <ArrowRight className="ml-2" />
          </GradientButton>
        </div>
      </div>
    </div>
  );
};